// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {GetAttributes, UpdateAttributesPositions, DeleteAttributeById} from "../../redux/actions";
import {deleteItem} from "../../utils/helperFunctions";

class Attributes extends Component {
    constructor(props) {
        super(props);
        this.deleteAttribute = deleteItem.bind(this, props.DeleteAttributeById, 'Բնութագիրը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetAttributes();
    }

    getNestableItems(list) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {

            items.push({
                id: item.id,
                index: index,
                title: item.title,
                isHidden: item.isHidden,
                withImage: false,
                largeItem: false,
                link: `attributes/edit/${item.id}`,
                deleteCb: () => this.deleteAttribute(item.id),
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedAttributeId = item.id;
        const {filtersList} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~filtersList.findIndex(m => m.id === movedAttributeId) &&
            ~positionedItems.findIndex(m => m.id === movedAttributeId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdateAttributesPositions(positionedItems);
            this.props.GetAttributes();
        }
    }

    render() {
        let {attributesList} = this.props;
        let items = this.getNestableItems(attributesList);

        return <PageWrapper pageTitle={'Բնութագրեր'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/attributes/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetAttributes,
    UpdateAttributesPositions,
    DeleteAttributeById
};

export default connect(mapStateToProps, mapDispatchToProps)(Attributes);
